import React from 'react';
import ServicePage from '../components/ServicePage';
import heroBillede from '../images/BelægningHero.jpg';

function Belaegning() {
  return (
    <ServicePage
      slug="belaegning"
      path="/belægning"
      navn="Belægning"
      seo={{
        title: 'Belægning – fliser & beton i Holbæk | JBC Entreprenøren',
        description: 'Belægning i Holbæk, Tølløse og på hele Sjælland: fliser, beton, asfalt og natursten til private og erhverv. Få et gratis tilbud fra lokale specialister.',
        image: 'https://jbcentreprenoeren.dk/images/og-belaegning.jpg',
        serviceName: 'Belægning og flisearbejde',
      }}
      hero={{
        titel: 'Professionel belægning',
        tekst: 'Belægnings-specialist med base i Undløse. Vi udfører fliser, beton og alle typer belægning for kunder på hele Sjælland.',
        cta: 'Få tilbud på belægning',
        billede: heroBillede,
        billedeAlt: 'Ny fliseterrasse lagt af JBC Entreprenøren',
      }}
      intro={{
        titel: 'Belægning til private og erhverv',
        tekst: [
          'JBC Entreprenøren laver belægning til både private og erhverv i Holbæk, Tølløse, Mørkøv, Jyderup og resten af Sjælland.',
          'Vi udfører alle typer belægningsarbejde og sørger for, at alt bliver gjort ordentligt – med lokalt kendskab til området.',
        ],
      }}
      ydelser={{
        titel: 'Vores belægningstjenester',
        punkter: [
          'Flisebelægning til terrasser og indkørsler',
          'Betonbelægning til større arealer',
          'Asfaltbelægning til veje og parkeringspladser',
          'Naturstensbelægning til have og udendørsarealer',
          'Reparation og vedligeholdelse af eksisterende belægninger',
          'Specialbelægninger til erhverv og industri',
        ],
      }}
      fordele={{
        titel: 'Derfor vælger kunder os til belægning',
        punkter: [
          'Lokal viden og erfaring i Nordvestsjælland',
          'Kvalitetsmaterialer fra anerkendte leverandører',
          'Professionel rådgivning og planlægning',
          'Konkurrencedygtige priser',
          'Fuld garanti på alt arbejde',
        ],
      }}
      kontaktTekst="Skal du have lavet belægning? Vi hjælper gerne med dit projekt."
    />
  );
}

export default Belaegning;
